import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireserviceinkharadiitpark() {



const cardData =
  {
    keyword: 'Swift Dzire Service in Kharadi IT Park',
    heading: 'Sanavi Travels: Swift Dzire Service in Kharadi IT Park',
    headingDescription: 'Sanavi Travels provides highly reliable, professionally managed, and comfort-focused Swift Dzire Service in Kharadi IT Park, designed specifically for IT professionals, corporate employees, business executives, HR teams, and visiting clients working in and around Kharadi. Kharadi IT Park is one of Pune’s fastest-growing technology and corporate hubs, with daily movement of employees, managers, consultants, and corporate guests requiring punctual, safe, and comfortable transportation. Our Swift Dzire cab services in Kharadi IT Park are ideal for daily office commute, employee pickup and drop, corporate travel, airport transfers, railway station pickups, client meetings, and local business travel. The Swift Dzire sedan is known for its smooth ride quality, fuel efficiency, spacious seating, and professional appearance, making it perfect for both regular office use and executive travel. All vehicles are well-maintained, clean, and available in AC and Non-AC variants to suit different budgets and comfort needs. Our trained and background-verified drivers are well-versed with Kharadi IT Park routes, peak office hours, traffic patterns, nearby residential areas, and major business corridors, ensuring timely pickups and hassle-free journeys. With flexible booking options, transparent pricing, and dependable service quality, Sanavi Travels ensures that Swift Dzire cab service in Kharadi IT Park delivers consistent comfort, safety, and efficiency for daily commuters as well as corporate travel requirements.',

    top: 'Swift Dzire Travel Use-Cases in Kharadi IT Park',


"topPlaces": [
  {
    "title": "Daily Office Commute in Kharadi IT Park",
    "description": "Swift Dzire service in Kharadi IT Park is extensively used for daily office commute by IT employees and corporate professionals. The comfortable sedan seating, smooth suspension, and air-conditioned interiors help reduce daily travel fatigue while ensuring punctual arrival and departure. Dedicated cab services offer reliable scheduling, safe late-evening travel, and stress-free commuting for professionals working long hours in IT companies."
  },
  {
    "title": "Employee Pickup and Drop Services",
    "description": "Employee pickup and drop using Swift Dzire cabs ensures safe, organized, and timely transportation for corporate staff. Fixed routes, trained drivers, and reliable vehicles support shift-based travel and rotational schedules, improving employee safety and satisfaction."
  },
  {
    "title": "Corporate Travel and Business Meetings",
    "description": "Swift Dzire cabs are ideal for corporate travel, client meetings, and inter-office movement in and around Kharadi IT Park. The professional appearance and comfortable interiors make it suitable for executives and visiting business guests."
  },
  {
    "title": "Airport Transfers from Kharadi IT Park",
    "description": "Business executives frequently require airport transfers for domestic and international travel. Swift Dzire service provides timely pickups and drops, sufficient luggage space, and smooth rides aligned with flight schedules, ensuring stress-free airport connectivity."
  },
  {
    "title": "Railway Station Pickups and Drops",
    "description": "Swift Dzire cabs are commonly used for railway station transfers for employees, clients, and visiting professionals. Organized pickups reduce delays and ensure comfortable connectivity between stations and Kharadi IT Park."
  },
  {
    "title": "Local Business Travel in Pune",
    "description": "Local business travel for meetings, site visits, and corporate errands is efficiently handled using Swift Dzire cabs. Easy maneuverability in traffic and fuel efficiency make it ideal for city travel."
  },
  {
    "title": "Corporate Events and Seminars",
    "description": "Corporate events, seminars, and training programs require coordinated transportation for staff and guests. Swift Dzire services ensure organized, punctual, and professional travel arrangements."
  },
  {
    "title": "Client and Guest Transportation",
    "description": "Swift Dzire cabs provide comfortable and professional transportation for corporate guests and clients visiting offices in Kharadi IT Park, helping maintain a positive business impression."
  },
  {
    "title": "Residential Connectivity Around Kharadi",
    "description": "Many employees reside in nearby areas such as Wagholi, Viman Nagar, and Hadapsar. Swift Dzire services ensure reliable daily connectivity between residential zones and IT Park offices."
  },
  {
    "title": "Flexible Multi-Route Travel",
    "description": "Corporate travel often involves multiple stops and route changes. Swift Dzire cab services handle flexible itineraries efficiently while maintaining punctuality and passenger comfort."
  }
]
,



"services": [
{
"name": "Swift Dzire Service in Kharadi IT Park",
"description": "Swift Dzire Service in Kharadi IT Park by Sanavi Travels offers a dependable, efficient, and comfortable transportation solution for IT professionals, corporate employees, executives, and business visitors. This service is ideal for daily office commute, employee transportation, corporate travel, airport transfers, railway pickups, and local business movement. The Swift Dzire sedan provides excellent ride comfort, fuel efficiency, spacious seating, and a professional look suitable for corporate usage. Vehicles are regularly serviced, cleaned, and available with AC and Non-AC options to match different comfort and budget preferences. Experienced drivers ensure punctual pickups, safe travel during peak hours, and smooth navigation through Kharadi IT Park and surrounding business corridors. With flexible booking options, transparent pricing, and consistent service quality, Swift Dzire service supports both short-term and long-term corporate travel needs with reliability and convenience."
},
{
"name": "AC Swift Dzire Hire Kharadi",
"description": "AC Swift Dzire Hire Kharadi offers a cool and comfortable travel experience, especially suitable for long working hours and summer travel. Fully air-conditioned interiors, comfortable seating, and smooth suspension make daily office commute and corporate travel relaxed and refreshing."
},
{
"name": "Non AC Swift Dzire Cab Kharadi",
"description": "Non AC Swift Dzire Cab Kharadi provides an economical travel option without compromising safety and reliability. Ideal for short-distance and regular travel, it offers fuel-efficient and cost-effective transportation for daily office use."
},
{
"name": "Swift Dzire for Office Commute Kharadi",
"description": "Swift Dzire for Office Commute Kharadi ensures employees reach offices on time with safe and organized transport. Fixed schedules, route familiarity, and professional drivers improve punctuality and reduce daily commute stress."
},
{
"name": "Swift Dzire for Corporate Travel Kharadi",
"description": "Swift Dzire for Corporate Travel Kharadi supports meetings, conferences, client visits, and executive travel. The sedan’s professional appearance and comfort enhance corporate image and travel efficiency."
},
{
"name": "Swift Dzire for Airport Transfer Kharadi",
"description": "Swift Dzire for Airport Transfer Kharadi ensures timely pickups and drops with adequate luggage space, comfortable seating, and smooth coordination with flight schedules."
},
{
"name": "Swift Dzire for Railway Pickup Kharadi",
"description": "Swift Dzire for Railway Pickup Kharadi provides reliable station transfers, reducing waiting time and ensuring smooth connectivity for business travelers and employees."
},
{
"name": "Affordable Swift Dzire Cab Hire Kharadi",
"description": "Affordable Swift Dzire Cab Hire Kharadi offers cost-effective travel solutions with transparent billing, making it suitable for individuals and companies managing regular transportation budgets."
},
{
"name": "Best Swift Dzire Service Kharadi",
"description": "Best Swift Dzire Service Kharadi by Sanavi Travels is trusted for punctuality, safety, professional drivers, and consistent service quality for corporate and office travel."
},
{
"name": "Swift Dzire with Driver Kharadi",
"description": "Swift Dzire with Driver Kharadi includes trained, verified chauffeurs familiar with Kharadi IT Park routes, traffic conditions, and professional etiquette, ensuring smooth and stress-free journeys."
},
{
"name": "Swift Dzire for Employee Pickup Kharadi",
"description": "Swift Dzire for Employee Pickup Kharadi focuses on safe, reliable, and punctual transportation for employees working flexible and late shifts in IT companies."
},
{
"name": "Swift Dzire for Local Sightseeing Kharadi",
"description": "Swift Dzire for Local Sightseeing Kharadi supports short city trips, business errands, and personal travel within Pune with comfort and efficiency."
},
{
"name": "Swift Dzire for Corporate Events Kharadi",
"description": "Swift Dzire for Corporate Events Kharadi manages transportation for seminars, training sessions, and official gatherings with organized and professional execution."
},
{
"name": "Luxury Swift Dzire Hire Kharadi",
"description": "Luxury Swift Dzire Hire Kharadi offers premium comfort, clean interiors, and refined travel experience suitable for executives, VIP guests, and corporate visitors."
}
],
"tableData": [
["Swift Dzire Service Kharadi", "Office Commute Cabs"],
["AC Swift Dzire", "Non AC Swift Dzire"],
["Airport Transfer Dzire", "Railway Pickup Dzire"],
["Employee Pickup Dzire", "Corporate Travel Dzire"],
["Local Business Travel", "Corporate Event Travel"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Expertise in Kharadi IT Park Travel",
    "WhyChoosedescription": "Sanavi Travels understands Kharadi IT Park commuting needs and provides optimized Swift Dzire cab solutions."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cars",
    "WhyChoosedescription": "Clean, regularly serviced Swift Dzire cars ensure smooth and comfortable travel every day."
  },
  {
    "WhyChooseheading": "Professional and Verified Drivers",
    "WhyChoosedescription": "Experienced drivers ensure safety, punctuality, and courteous service."
  },
  {
    "WhyChooseheading": "Reliable Office Commute Support",
    "WhyChoosedescription": "Dedicated cab services help maintain office schedules and productivity."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Hourly, daily, and long-term booking options suit diverse corporate needs."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear and upfront pricing helps manage travel budgets efficiently."
  },
  {
    "WhyChooseheading": "Safe and Secure Travel",
    "WhyChoosedescription": "Background-verified drivers and maintained vehicles ensure passenger safety."
  },
  {
    "WhyChooseheading": "Trusted Corporate Cab Partner",
    "WhyChoosedescription": "Sanavi Travels is trusted for consistent Swift Dzire services in Kharadi IT Park."
  }
]

}

const faqData = [
  {
    question: 'Do you provide Swift Dzire service in Kharadi IT Park?',
    answer: 'Yes, Sanavi Travels offers dedicated Swift Dzire cab services in Kharadi IT Park.'
  },
  {
    question: 'Are AC and Non AC Swift Dzire cabs available?',
    answer: 'Yes, both AC and Non AC Swift Dzire options are available.'
  },
  {
    question: 'Can I use Swift Dzire for daily office commute?',
    answer: 'Yes, Swift Dzire cabs are ideal for daily office and employee commute.'
  },
  {
    question: 'Do you provide airport transfers from Kharadi?',
    answer: 'Yes, airport pickup and drop services are available.'
  },
  {
    question: 'Is the driver included in the service?',
    answer: 'Yes, all Swift Dzire services include a trained and verified driver.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Deshmukh',
    feedback: 'Very comfortable Swift Dzire service for my daily office commute in Kharadi IT Park.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'Professional drivers and punctual service. Perfect for corporate travel.',
    rating: 5
  }
];
































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire Service in Kharadi IT Park - Sanavi Travels",
  "description": "Sanavi Travels offers Swift Dzire service in Kharadi IT Park for office commute, corporate travel, airport and railway pickups, employee transport, local sightseeing, and corporate events. AC and Non-AC Swift Dzire vehicles are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Swift Dzire Service in Kharadi IT Park | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Swift Dzire in Kharadi IT Park with Sanavi Travels. AC & Non-AC vehicles for office commute, corporate travel, airport, railway, employee transport, local sightseeing, and corporate events with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/263.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireserviceinkharadiitpark;